import { useCallback, useContext } from "react";
import {
  DISCORD_INVITE_URL,
  DISCORD_MISSION01_INTRO_CHANNEL_URL,
} from "../../constants";
import { useTokenAuth } from "../../hooks";
import { useMission, useRefreshMission } from "../../hooks/missions";
import { AppContext } from "../../providers/AppContext";
import { theme } from "../../theme";
import MissionCard from "./MissionCard";
import {
  MissionCardDescription,
  MissionCardFlexRow,
  MissionCardImage,
  MissionCardImagesContainer,
  MissionCardTasksContainer,
  MissionRedacted,
  MissionRedactedBackground
} from "./MissionsContent.styled";
import MissionTask from "./MissionTask";
import { useMessages } from "../../hooks/messages";

const Mission01TimeToEat = () => {
  const { isAuthenticated } = useTokenAuth();
  const { setShowLogin } = useContext(AppContext);

  const handleTask1Action = () => {
    setShowLogin(true);
  };

  const handleTask2Action = () => {
    window.open(DISCORD_INVITE_URL, "_blank", "noopener,noreferrer");
  };

  const handleTask3Action = () => {
    window.open(
      DISCORD_MISSION01_INTRO_CHANNEL_URL,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const mission = useMission(0, {
    refetchInterval: 10000, // Refresh every 10 seconds
  });
  const messages = useMessages({
    refetchInterval: 10000, // Refresh every 10 seconds
  });
  console.log(messages.data);

  // TODO - check for task completion messages, re-fetch

  const refreshMissionTask = useRefreshMission();

  const isMissionComplete = mission.data?.tasks?.every((task) => task) || false;

  const tasks = [
    {
      id: 1,
      text: "Sign up for Basejump",
      completed: mission.data?.tasks[0],
      reward: "Got a Drink! 🥤",
      actionHandler: handleTask1Action,
    },
    {
      id: 2,
      text: "Join the Basejump Discord",
      completed: mission.data?.tasks[1],
      reward: "Got a Burger! 🍔",
      actionHandler: handleTask2Action,
    },
    {
      id: 3,
      text: "Say hi to #general",
      completed: mission.data?.tasks[2],
      reward: "Got a Ramen! 🍜",
      actionHandler: handleTask3Action,
    },
  ];

  const handleRefreshMission = useCallback(async () => {
    if (!isAuthenticated()) {
      setShowLogin(true);
      return;
    }
    const payload = { missionId: 0 };
    refreshMissionTask.mutate(payload);
  }, [isAuthenticated, setShowLogin, refreshMissionTask]);

  return (
    <>
      <MissionCard
        num="01"
        title="Time to Eat"
        enabled
        scanning={!isMissionComplete && mission.isLoading}
        isComplete={isMissionComplete}
        onRefreshMission={handleRefreshMission}
        isLoadingRefresh={refreshMissionTask.isLoading}
      > 
        <MissionCardFlexRow>
          <MissionCardDescription>
            Get <strong>food and drink rewards</strong> by completing quests:
          </MissionCardDescription>

          <MissionCardImagesContainer>
            <MissionCardImage
              src="/assets/missions/01/drink.png"
              alt="Mission 1 image 1"
              />
            <MissionCardImage
              src="/assets/missions/01/ramen.png"
              alt="Mission 1 image 3"
              />
            <MissionCardImage
              src="/assets/missions/01/burger.png"
              alt="Mission 1 image 2"
              />
          </MissionCardImagesContainer>
        </MissionCardFlexRow>

        <MissionCardTasksContainer>
          <MissionTask
            loading={mission.isLoading}
            text={tasks[0].text}
            completed={tasks[0].completed}
            reward={tasks[0].reward}
            actionHandler={tasks[0].actionHandler}
            primaryColor={theme.baseRed}
          />
          <MissionTask
            loading={mission.isLoading}
            text={tasks[1].text}
            completed={tasks[1].completed}
            reward={tasks[1].reward}
            actionHandler={tasks[1].actionHandler}
            primaryColor={theme.baseRed}
          />
          <MissionTask
            loading={mission.isLoading}
            text={tasks[2].text}
            hint={tasks[2].hint}
            completed={tasks[2].completed}
            reward={tasks[2].reward}
            actionHandler={tasks[2].actionHandler}
            primaryColor={theme.baseRed}
          />
        </MissionCardTasksContainer>
        {isMissionComplete &&
          <MissionRedactedBackground>
            <MissionRedacted style={{ color: theme.selection }}>[COMPLETE]</MissionRedacted>
          </MissionRedactedBackground>
        }
      </MissionCard>
    </>
  );
};

export default Mission01TimeToEat;
